module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/haircut-mobile@3x-cf35ed29d9767fd031ca6884e2cb2d13.jpg";